export const REGEX = {
  AUS_MOBILE_PHONE: /^(?:\+?61|0)[4](?:[ -]?[0-9]){8}$/,
  ALPHANUMERIC_NO_SPACES: /^[a-zA-Z0-9]*$/,
  SIM: /^(\d{13})?$/,
  SIX_DIGITS: /^(\d{6})?$/,
  FIRST_NAME: /^(?=[a-zA-Z])[a-zA-Z\- ']{1,40}$/,
  LAST_NAME: /^(?=[a-zA-Z])[a-zA-Z\- ']{1,80}$/,
  // Only allow numbers, and /
  // eslint-disable-next-line no-useless-escape
  DATE_OF_BIRTH_INPUTS: /[^0-9\/]/,

  // positive lookahead for (lowercase, uppercase, digit, owasp password special characters)
  // within at least 8 characters
  // eslint-disable-next-line no-useless-escape
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\\" !"#$%&'()*+,-.\/:;<=>?@[\]^_`{|}~"]).{8,}$/,
  EMAIL:
    /^(([^<>()[\]\\.,;:\s@"+]+(\.[^<>()[\]\\.,;:\s@"+]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
  NUMBER_ONLY: /^[0-9]*$/,
  NUMBER_INPUT: /^-?[0-9](.[0-9])?.*$/,
  NUMBER_INPUT_TWO_DECIMALS: /^[0-9]*\.?[0-9]{0,2}$/
};
